export default __webpack_public_path__ + "static/media/icon1.f7c9bdad.svg";